// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { type MutateOptions, useMutation } from '@tanstack/react-query'

import { type InsurancePremium } from '../../brokers/types'
import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export type InsurancePremiumPatchParam = {
  premium_ids: string[]
  premium_amount: string
  loss_amount: string
  coverage_audit_reason: string
}

export type EnrollmentMutateOptions =
  | MutateOptions<
      InsurancePremium[],
      GrapeAPIErrorType,
      InsurancePremiumPatchParam,
      unknown
    >
  | undefined

export function useModifyEnrollmentInsurancePremium ({
  enrollmentId,
  memberId,
}: {
  enrollmentId: string
  memberId: string
}) {
  return useMutation<
    InsurancePremium[],
    GrapeAPIErrorType,
    InsurancePremiumPatchParam
  >({
    mutationFn: async (params) => {
      const request = new FetchRequest(
        'put',
        `/api/web/brokers/members/${memberId}/enrollments/${enrollmentId}/insurance_premiums`,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: {
            ...params,
          },
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
